import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-black relative mb-5 w-full border py-2.5 px-3 tablet:mb-9" }
const _hoisted_2 = { class: "max-w-[95%]" }
const _hoisted_3 = { class: "flex items-center justify-between pb-2" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "text-lg font-bold leading-6" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = {
  key: 0,
  class: "pb-2.5 text-[0.8rem] leading-none opacity-40"
}
const _hoisted_9 = { class: "grid grid-cols-3 gap-y-5.5 gap-x-2.5" }
const _hoisted_10 = { class: "flex flex-col items-center justify-between" }
const _hoisted_11 = { class: "flex items-center pt-1.5" }
const _hoisted_12 = { class: "pr-1 text-center text-md font-semibold" }
const _hoisted_13 = { class: "max-w-[90%] text-center text-xs leading-normal tablet:text-sm" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "flex py-1.5" }
const _hoisted_16 = { class: "mt-auto" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_image = _resolveComponent("v-image")
  const _component_cart_qty_picker = _resolveComponent("cart-qty-picker")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "absolute -top-4 -right-2.5 grid aspect-square h-7 place-items-center rounded-full border border-black-20 bg-white",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.deleteEntireSet && $options.deleteEntireSet(...args)))
    }, [
      _createVNode(_component_v_icon, {
        icon: "close",
        width: 13,
        height: 13,
        color: "#878585"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: $options.parentItem.url
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString($options.parentItem.title), 1)
        ], 8, _hoisted_4),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("del", {
            class: _normalizeClass(["pr-1 text-sm font-medium opacity-80 tablet:pr-2 tablet:text-md", $data.skeletonClass])
          }, _toDisplayString($options.originPrice), 3),
          _createElementVNode("span", {
            class: _normalizeClass(["text-sm font-medium tablet:text-md", $data.skeletonClass])
          }, _toDisplayString($options.price), 3),
          _createElementVNode("button", {
            class: "btn-primary ml-4 px-4 py-1 text-md",
            onClickOnce: _cache[1] || (_cache[1] = $event => ($options.editStarterSet($options.childrenItemsDefault[0].properties._StarterSetKey))),
            textContent: _toDisplayString($data.locale.edit_starterset)
          }, null, 40, _hoisted_7)
        ])
      ]),
      ($options.parentItem.properties._IncludedItems)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($options.parentItem.properties._IncludedItems), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_image, {
            lazyloaded: "",
            image: $options.parentItem.image,
            class: "aspect-cart-starterset w-full object-cover"
          }, null, 8, ["image"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.childrenItemsDefault, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key,
            class: "flex flex-col items-center leading-normal"
          }, [
            _createVNode(_component_v_image, {
              lazyloaded: "",
              image: item.image,
              class: "aspect-square w-full object-contain"
            }, null, 8, ["image"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(item.quantity) + "x ", 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(item.title), 1)
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.childrenItemsOptional, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.key,
            class: "relative flex flex-col items-center justify-between text-xs leading-normal tablet:text-sm"
          }, [
            _createElementVNode("button", {
              type: "button",
              class: "absolute -top-3 -right-2.5 grid aspect-square h-6 place-items-center rounded-full border border-black-20 bg-white",
              onClick: $event => (_ctx.debouncedDelete(item))
            }, [
              _createVNode(_component_v_icon, {
                icon: "close",
                width: 11,
                height: 11,
                color: "#878585"
              })
            ], 8, _hoisted_14),
            _createVNode(_component_v_image, {
              lazyloaded: "",
              image: item.image,
              class: "aspect-square w-full object-contain"
            }, null, 8, ["image"]),
            _createElementVNode("span", {
              class: _normalizeClass(["max-w-[90%] pt-1.5 text-center", $data.skeletonClass])
            }, _toDisplayString(item.title), 3),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", {
                class: _normalizeClass($data.skeletonClass)
              }, _toDisplayString(item.final_discounted_price), 3),
              _createElementVNode("del", {
                class: _normalizeClass(["ml-2 opacity-80", $data.skeletonClass])
              }, _toDisplayString(item.final_original_price), 3)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createBlock(_component_cart_qty_picker, {
                key: item.quantity,
                product: item,
                onIsClicked: $options.toggleSkeleton
              }, null, 8, ["product", "onIsClicked"]))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}